import { BasicQueryStringUtils } from "@ting/app-auth";
export class QueryStringUtils extends BasicQueryStringUtils {
    parse(input) {
        return this.parseQueryString(input.search);
    }
}
